
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { useEffect, useState, useRef } from "react"; 
import { CustomerExecutiveDTO } from "../../models/CustomerExecutive/CustomerExecutive-model";
import CustomerExecutiveService from "../../services/CustomerExecutives/CustomerExecutivesservice";

interface DataTableProps {
  data: CustomerExecutiveDTO[];
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (event: any) => void;
  isEmptyState?: boolean;
  onAssign: (customerId: number, executiveId: number) => void;
   onSortChange: (field: string, order: 1 | -1) => void; 
}

const AssignExecutiveDatatable: React.FC<DataTableProps> = (props) => {
  const [sortField, setSortField] = useState<string>("createdDate");
  const [sortOrder, setSortOrder] = useState<1 | -1>(1);
  const [executiveList, setExecutiveList] = useState<
    { salesExecutiveId: number; salesExecutiveName: string }[]
  >([]);
  

  const toast = useRef<Toast>(null); 
  const showMessage = (
    summary: string,
    detail: string,
    severity: "success" | "warn" | "error"
  ) => {
    toast.current?.show({ severity, summary, detail, life: 3000 });
  };

  useEffect(() => {
    const fetchExecutives = async () => {
      const data = await CustomerExecutiveService.getCustomerExecutiveList();
      setExecutiveList(data);
    };

    fetchExecutives();
  }, []);

  const executiveEditor = (options: any) => (
    <Dropdown
      options={executiveList}
      optionLabel="salesExecutiveName"
      optionValue="salesExecutiveId"
      value={options.rowData.executiveId ?? null}
      onChange={(e) => {
        options.editorCallback(e.value);
        options.rowData.executiveId = e.value;
        options.rowData.customerExecutiveName =
          executiveList.find((x) => x.salesExecutiveId === e.value)
            ?.salesExecutiveName || "";
      }}
      className="w-full"
    />
  );

const onSort = (e: DataTableSortEvent) => {
  const newOrder = sortField === e.sortField && sortOrder === 1 ? -1 : 1;
  setSortField(e.sortField || "");
  setSortOrder(newOrder);
  props.onSortChange(e.sortField || "", newOrder); 
};


const onRowEditComplete = async (e: any) => {
 
  const { newData } = e;

  const selectedExecutiveId = newData.executiveId;
  const customerId = newData.customerId;
  if (selectedExecutiveId != null && customerId != null) {
    try {
      console.log(" Sending payload to API:", {
        customerId,
        salesExecutiveId: selectedExecutiveId
      });
      const response = await CustomerExecutiveService.updateCustomerExecutive({
        customerId,
        salesExecutiveId: selectedExecutiveId,       
      });

      console.log(" API response received:", response);

      if (response) {
        showMessage("Update", "Executive updated successfully", "success");
        props.onAssign(customerId, selectedExecutiveId);
      } else {
        showMessage("Update", "Failed to update executive", "error");
      }
    } catch (error) {
      console.error(" Exception occurred while calling update API:", error);
      showMessage("Error", "An error occurred", "error");
    }
  } else {
    showMessage("Missing Data", "Please select executive", "warn");
  }
};
const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }); 
};


  return (
    <div className="col-12">
      <Toast ref={toast} /> 
      <div className="card border-noround p-2">
        <DataTable
          value={props.data}
          paginator
          rows={props.pageSize}
          rowsPerPageOptions={[5, 10, 25, 50,100]}
          totalRecords={props.totalRecords}
          lazy
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate={
            props.isEmptyState
              ? "{totalRecords} records"
              : "{first} to {last} of {totalRecords}"
          }
          first={(props.pageNumber - 1) * props.pageSize}
          onPage={props.onPageChange}
          sortMode="single"
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={onSort}
          emptyMessage={props.isEmptyState ? null : "No customers found"}
          editMode="row"
          onRowEditComplete={onRowEditComplete}
        >
          <Column field="customerName" header="Name" style={{ width: "10%" }}  />
          <Column field="customerId" header="ID" style={{ display: 'none' }} />
          <Column field="contact" header="Contact" style={{ width: "12%" }} />
          <Column
         field="createdDate"
          header="Created Date"
        style={{ width: "10%" }}
         body={(rowData) => formatDate(rowData.createdDate)}
         sortable
         sortField="createdDate"  
          />

          <Column field="address" header="Address" style={{ width: "25%" }} />
          <Column
            field="executiveId"
            header="Customer Executive"
            style={{ width: "15%" }}
            editor={(options) => executiveEditor(options)}
            body={(rowData) => rowData.customerExecutiveName || "Unassigned"}
          />
          <Column
            rowEditor
            header="Assign"
            headerStyle={{ width: "5%" }}
            bodyStyle={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default AssignExecutiveDatatable;
